import React, { useState, useEffect } from "react";
import s from "../../../../../../Shared/AgencyModal/AgencyModal.module.css";

import {
  Modal,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
  TextField,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CircularProgress from "@mui/material/CircularProgress";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import ordersService from "../../../../../../../api/delivery/ordersServices";
import { useNotificationContext } from "../../../../../../Notifications/CustomNotifications";

export default function OrdersModal({
  open,
  setOpen,
  setOrderSelect,
  setForm,
  form,
}) {
  const { textColor } = useSelector((state) => state.local);
  const { t } = useTranslation();
  const notification = useNotificationContext();

  const [input, setInput] = useState("");

  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);
  const [searching, setSearching] = useState(false);

  const [filters, setFilters] = useState({
    orderId: 0,
    gameId: 0,
    supplierId: 0,
  });

  const [sort, setSort] = useState({
    field: "",
    criteria: "DESC",
  });

  const fetchOrders = () => {
    setLoading(true);
    ordersService
      .getAllOrders(1, 10, sort)
      .then((res) => {
        let filteredByProvider = res.content.filter(
          (item) => item.supplier?.id === form?.supplierId,
        );
        setResults(filteredByProvider);
      })
      .then(() => setLoading(false))
      .catch((error) => {
        notification.error("Error ep", error.message);
      });
  };

  useEffect(() => {
    if (searching) {
      setLoading(true);
      ordersService
        .searchOrder(1, 10, filters)
        .then((res) => {
          let filteredByProvider = res.content.filter(
            (item) => item.supplier?.id === form?.supplierId,
          );
          if (filteredByProvider) {
            setResults(
              filteredByProvider.filter(function (item, index, self) {
                return (
                  self.findIndex(
                    (p) => JSON.stringify(p) === JSON.stringify(item),
                  ) === index
                );
              }),
            );
          } else {
            setResults([]);
          }
        })
        .then(() => setLoading(false));
    } else {
      fetchOrders();
    }
  }, [searching]);

  // WARNING: This was changed in order to pass the detailList when is added in the first stepper
  const handleSetSelected = (item) => {
    const details = item.detailOrdersList;
    let payload = details.map((detail) => {
      return {
        id: detail.id,
        amount: detail.amount,
        nroCouponFrom: detail.nroCouponFrom,
        nroCouponTo: detail.nroCouponTo,
        gameId: detail?.gameId ?? detail.game.id,
        raffleId: detail?.raffleId ?? detail.raffle.id,
      };
    });

    setOrderSelect(item);
    setForm((prev) => ({ ...prev, orderId: item.id, detailList: payload }));
    setOpen(false);
  };

  const cellStyles = {
    fontFamily: "Roboto, sans-serif",
    fontSize: ".8rem",
    fontWeight: "400",
    borderBottom: "1px solid rgba(0, 0, 0, 0.455)",
    cursor: "pointer",
  };

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Grid container>
        <Grid
          container
          item
          xs={12}
          md={6}
          lg={5}
          className={s.boxModal}
          sx={{ bgcolor: "#EEEEEE" }}
        >
          <Grid
            item
            container
            xs={12}
            sx={{ justifyContent: "center", alignItem: "center" }}
          >
            <Grid item xs={11} className={s.exit}>
              <div className={s.titleModal}>
                <p>{t("purchaseOrders")}</p>
                <span>{t("select")}</span>
              </div>
              <CloseIcon
                onClick={() => setOpen(false)}
                className={s.exitIcon}
                sx={{ color: "primary.dark" }}
              />
            </Grid>

            <Grid
              item
              container
              xs={11}
              sx={{
                mb: 2,
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
              className={s.search}
            >
              <Grid item xs={11.4} md={11.4} lg={11.4} sx={{ mb: 2, mr: 2 }}>
                <TextField
                  type="number"
                  value={filters.orderId}
                  label={t("orderNumber")}
                  sx={{ width: "100%" }}
                  onChange={(e) =>
                    setFilters((prev) => ({
                      ...prev,
                      orderId: e.target.value * 1,
                    }))
                  }
                />
              </Grid>
            </Grid>
            <Grid item container xs={11} md={5.5} lg={5.5} sx={{ mb: 2 }}>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  type="submit"
                  sx={{ width: "90%" }}
                  disabled={!filters.orderId}
                >
                  {t("find")}
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  type="submit"
                  sx={{ width: "90%" }}
                  onClick={() => {
                    setFilters((prev) => ({ ...prev, orderId: 0 }));
                    setSearching(false);
                  }}
                  disabled={!searching}
                >
                  {t("back")}
                </Button>
              </Grid>
            </Grid>

            {loading ? (
              <Grid item xs={12} className={s.loader}>
                <CircularProgress />
              </Grid>
            ) : results?.length ? (
              <Grid item container xs={11} className={s.data}>
                <TableContainer className={s.tableContainer}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            backgroundColor: "primary.main",
                            color: textColor,
                            fontSize: ".8rem",
                            fontWeight: 500,
                            fontFamily: "Roboto, sans-Serif",
                          }}
                        >
                          {t("number")}
                        </TableCell>
                        <TableCell
                          sx={{
                            backgroundColor: "primary.main",
                            color: textColor,
                            fontSize: ".8rem",
                            fontWeight: 500,
                            fontFamily: "Roboto, sans-Serif",
                          }}
                        >
                          {t("date")}
                        </TableCell>
                        <TableCell
                          sx={{
                            backgroundColor: "primary.main",
                            color: textColor,
                            fontSize: ".8rem",
                            fontWeight: 500,
                            fontFamily: "Roboto, sans-Serif",
                          }}
                        >
                          {t("provider")}
                        </TableCell>
                        <TableCell
                          sx={{
                            backgroundColor: "primary.main",
                            color: textColor,
                            fontSize: ".8rem",
                            fontWeight: 500,
                            fontFamily: "Roboto, sans-Serif",
                          }}
                        >
                          {t("observations")}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {results.map((p, i) => {
                        return (
                          <TableRow
                            key={i}
                            sx={{
                              "&:hover": { backgroundColor: "secondary.light" },
                            }}
                            onClick={() => handleSetSelected(p)}
                          >
                            <TableCell
                              sx={{
                                ...cellStyles,
                                backgroundColor:
                                  i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                              }}
                            >
                              {p.id.toString().padStart(5, "0")}
                            </TableCell>
                            <TableCell
                              sx={{
                                ...cellStyles,
                                backgroundColor:
                                  i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                              }}
                            >
                              {p.dateCreate.split("T")[0]}
                            </TableCell>
                            <TableCell
                              sx={{
                                ...cellStyles,
                                backgroundColor:
                                  i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                              }}
                            >
                              {p.supplier.businessName}
                            </TableCell>
                            <TableCell
                              sx={{
                                ...cellStyles,
                                backgroundColor:
                                  i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                              }}
                            >
                              {p.observations}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            ) : (
              <Grid item xs={12} className={s.noresult}>
                {t("noResults")}
              </Grid>
            )}
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                my: 3,
              }}
            >
              <Button
                size="small"
                variant="contained"
                onClick={() => {
                  setOpen(false);
                }}
              >
                {t("cancel")}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
}
